import React, { useState, useEffect } from 'react';
import './refer.css';
import Topbar from '../../component/Topbar';
import SideMenu from '../../component/SideMenu';
import { baseurl } from '../../baseurl';
import axios from 'axios';
import Swal from 'sweetalert2';

import logo from "../../asset/img/colorbg.png";


const Refer = () => {
  // --- Dynamic State ---
  const [referralLink, setReferralLink] = useState("Loading...");
  const [stats, setStats] = useState({ total: 0, successful: 0, earnings: 0, pending: 0 });
  const [referralHistory, setReferralHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openFaqIndex, setOpenFaqIndex] = useState(0);

  const userToken = localStorage.getItem('userToken');

  // --- Fetch Data on Load ---
  useEffect(() => {
    fetchReferralData();
  }, []);

  const fetchReferralData = async () => {
    try {
      const response = await axios.get(`${baseurl}getReferralDetails`, {
        headers: { Authorization: `Bearer ${userToken}` }
      });
      if (response.data.success) {
        const { link, stats, history } = response.data.data;
        setReferralLink(link);
        setStats(stats);
        setReferralHistory(history);
      }
    } catch (err) {
      console.error("Error fetching referral data", err);
    }
  };

  // --- Send Invitation (Dynamic) ---
const handleReferSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const formData = new FormData(e.target);
    
    const payload = {
      friendName: formData.get('friendName'),
      friendEmail: formData.get('friendEmail'),
      message: formData.get('message')
    };

    try {
      const response = await axios.post(`${baseurl}sendReferralInvite`, payload, {
        headers: { Authorization: `Bearer ${userToken}` }
      });
      
      if (response.data.success) {
        Swal.fire({
          icon: 'success',
          title: 'Sent!',
          text: `Invitation sent to ${payload.friendName}`,
          confirmButtonColor: '#6d28d9'
        });
        e.target.reset();
        fetchReferralData(); // Refresh history
      }
    } catch (err) {
      // --- UPDATED ERROR LOGIC ---
      // This catches the "Already invited" message from your backend
      const errorMessage = err.response?.data?.message || 'Failed to send invitation. Please try again.';
      
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: errorMessage,
        confirmButtonColor: '#6d28d9'
      });
    } finally {
      setLoading(false);
    }
  };

  // --- Copy Link Helper ---
  const copyToClipboard = (e) => {
    const btn = e.currentTarget;
    navigator.clipboard.writeText(referralLink).then(() => {
      const originalHTML = btn.innerHTML;
      btn.innerHTML = '<i class="fas fa-check"></i> Copied!';
      btn.style.background = '#00b894';
      setTimeout(() => {
        btn.innerHTML = originalHTML;
        btn.style.background = 'linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)';
      }, 2000);
      showNotification('Referral link copied!');
    });
  };

  const showNotification = (message) => {
    const notification = document.createElement('div');
    notification.textContent = message;
    notification.className = "refer-toast-msg"; // Add this class to your CSS
    notification.style.cssText = `
        position: fixed; top: 80px; right: 20px; background: #6a11cb; color: white;
        padding: 12px 20px; border-radius: 8px; z-index: 10000; font-size: 14px;
    `;
    document.body.appendChild(notification);
    setTimeout(() => notification.remove(), 3000);
  };

  // --- Social Share Handlers ---
const shareEmail = () => {
  const subjectText = "Grow your business with Measro";
  const bodyText = `Join me on Measro.com! Use my link to sign up and we both get $10 credit: ${referralLink}`;

  const subject = encodeURIComponent(subjectText);
  const body = encodeURIComponent(bodyText);
  
  // 1. Try opening the system's default email client app
  window.open(`mailto:?subject=${subject}&body=${body}`, '_self');

  // 2. Fallback Mechanism: Check if a native app actually opened
  let appOpened = false;

  // If a native app opens, the browser window will lose focus
  const handleVisibilityChange = () => {
    if (document.hidden) {
      appOpened = true;
    }
  };

  document.addEventListener('visibilitychange', handleVisibilityChange);

  // Wait 1.5 seconds. If the window never lost focus, open Outlook in the browser
  setTimeout(() => {
    document.removeEventListener('visibilitychange', handleVisibilityChange);
    
    if (!appOpened) {
      console.log("No native email app detected. Redirecting to Outlook Web...");
      
      // Microsoft Outlook Web compose URL format
      const outlookWebUrl = `https://outlook.live.com/default.aspx?rru=compose&subject=${subject}&body=${body}`;
      
      // Open Outlook Web in a new browser tab
      window.open(outlookWebUrl, '_blank');
    }
  }, 1500);
};

  const shareWhatsApp = () => {
    const msg = encodeURIComponent(`Hey! Check out Measro.com. Use my link to sign up and we both get $10 credit: ${referralLink}`);
    window.open(`https://wa.me/?text=${msg}`);
  };

  const shareFacebook = () => {
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(referralLink)}`);
  };

  const shareSMS = () => {
    const msg = encodeURIComponent(`Use my link for Measro.com. We both get $10 credit! ${referralLink}`);
    window.open(`sms:?&body=${msg}`);
  };

  return (
    <div className="app-container">
      <Topbar />
      <div className="main-wrapper" style={{ background: '#F4F7FE', display: 'flex' }}>
        <SideMenu />

        <div className="profile-content-container p-3" style={{ flex: 1, overflow: 'auto' }}>
          {/* Page Header */}
 

          <div className='page-title-section mb-3'>
                                <h1>Refer a Friend & Earn</h1>
                                <p className='page-subtitle' >Earn $10 rewards for every successful referral</p>
                            </div>


          <div className="main-cards-container">
            {/* Form Card */}
            <div className="refer-form-container">
              <h2 className="form-title">Refer a Friend Directly</h2>
              <form className="refer-form" onSubmit={handleReferSubmit}>
                <div className="form-group">
                  <label className="input-label">Friend's Name</label>
                  <input name="friendName" type="text" className="form-input" placeholder="Full name" required />
                </div>
                <div className="form-group">
                  <label className="input-label">Friend's Email</label>
                  <input name="friendEmail" type="email" className="form-input" placeholder="Email address" required />
                </div>
                <div className="form-group">
                  <label className="input-label">Your Message</label>
                  <textarea name="message" className="form-textarea" defaultValue="Hey! Check out Measro.com, it's great for landscaping measurements." />
                </div>
                <button type="submit" className="btn-submit" disabled={loading}>
                  <i className={loading ? "fas fa-spinner fa-spin" : "fas fa-paper-plane"}></i> 
                  {loading ? " Sending..." : " Send Invitation"}
                </button>
              </form>
            </div>

            {/* Benefit Card */}
            <div className="image-card">
              <div className="image-placeholder">
                {/* <div className="logo-large">M</div> */}
<div className="d-flex align-items-center">
          
            <img src={logo} className='img-fluid' style={{maxHeight:"40px", marginBottom: "10px"}} />
        </div>
                  
                {/* <h3>Measro.com</h3> */}
                <p>Professional Solutions</p>
              </div>
              <div className="card-content">
                <ul className="features-list2">
                  <li><i className="fas fa-check-circle"></i> Accurate measurements</li>
                  <li><i className="fas fa-check-circle"></i> Project tools</li>
                  <li><i className="fas fa-award" style={{ color: '#ffc107' }}></i> <strong>$10 credit for both</strong> </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Share Link Box */}
          <div className="share-options-container">
            <div className="share-options-header">
              <h3>Your Referral Link</h3>
              <div className="referral-link-box">
                <div className="referral-link-text">{referralLink}</div>
                <button className="btn-copy-small" onClick={copyToClipboard}>
                  <i className="fas fa-copy"></i> Copy
                </button>
              </div>
            </div>
            <div className="share-icons-container">
              <div className="share-icon-box" onClick={shareEmail}><i className="fas fa-envelope icon-email"></i></div>
              <div className="share-icon-box" onClick={shareWhatsApp}><i className="fab fa-whatsapp icon-whatsapp"></i></div>
              <div className="share-icon-box" onClick={shareFacebook}><i className="fab fa-facebook icon-facebook"></i></div>
              {/* <div className="share-icon-box" onClick={shareSMS}><i className="fas fa-sms icon-sms"></i></div> */}
            </div>
          </div>

          {/* Stats Section */}
          <div className="stats-container">
            <h2 className="form-title">Your Referral Progress</h2>
            <div className="stats-grid">
              <div className="stat-item">
                <div className="stat-number">{stats.total}</div>
                <div className="stat-label">Total Referrals</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">{stats.successful}</div>
                <div className="stat-label">Successful</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">${stats.earnings}</div>
                <div className="stat-label">Total Earned</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">{stats.pending}</div>
                <div className="stat-label">Pending</div>
              </div>
            </div>
          </div>

          {/* Referral Table Section (NEW) */}
          <div className="referral-history-section mt-5 bg-white p-4 rounded shadow-sm">
            <h2 className="form-title">Referral History</h2>
            <div className="table-responsive">
              <table className="table refer-history-table">
                <thead>
                  <tr>
                    <th>Friend</th>
                    <th>Email</th>
                    <th>Date Sent</th>
                    <th>Status</th>
                    <th>Reward</th>
                  </tr>
                </thead>
                <tbody>
                  {referralHistory.length > 0 ? (
                    referralHistory.map((row, index) => (
                      <tr key={index}>
                        <td>{row.name}</td>
                        <td>{row.email}</td>
                        <td>{new Date(row.date).toLocaleDateString()}</td>
                        <td>
                          <span className={`badge-status ${row.status.toLowerCase()}`}>
                            {row.status}
                          </span>
                        </td>
                        <td><strong>{row.reward > 0 ? `$${row.reward}` : '-'}</strong></td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5" className="text-center py-4">No referrals yet. Start sharing!</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          {/* FAQ */}
          <div className="faq-section">
        <h2 className="faq-title">Frequently Asked Questions</h2>

        <div className="faq-item">
          <div className="faq-question" onClick={() => setOpenFaqIndex(openFaqIndex === 0 ? null : 0)}>
            How do I know if my referral has signed up?
            <i className={`fas ${openFaqIndex === 0 ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i>
          </div>
          {openFaqIndex === 0 && (
            <div className="faq-answer" style={{ display: 'block' }}>
              You'll receive a notification and email when someone signs up using your referral link.
            </div>
          )}
        </div>

        <div className="faq-item">
          <div className="faq-question" onClick={() => setOpenFaqIndex(openFaqIndex === 1 ? null : 1)}>
            When will I receive my reward?
            <i className={`fas ${openFaqIndex === 1 ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i>
          </div>
          {openFaqIndex === 1 && (
            <div className="faq-answer" style={{ display: 'block' }}>
              Rewards are credited as soon as your referral completes their first project.
            </div>
          )}
        </div>

        <div className="faq-item">
          <div className="faq-question" onClick={() => setOpenFaqIndex(openFaqIndex === 2 ? null : 2)}>
            Is there a limit to how many people I can refer?
            <i className={`fas ${openFaqIndex === 2 ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i>
          </div>
          {openFaqIndex === 2 && (
            <div className="faq-answer" style={{ display: 'block' }}>
              No limit! Refer as many fellow landscapers as you want.
            </div>
          )}
        </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default Refer;